import { alpha, type Theme } from '@mui/material/styles';

export function getSeverityStyles(theme: Theme, severity: string) {
  const colors: Record<string, string> = {
    critical: theme.palette.error.main,
    high: theme.palette.warning.main,
    medium: theme.palette.warning.dark,
    low: theme.palette.success.main,
  };

  const color = colors[severity] ?? theme.palette.primary.main;
  return {
    color,
    bg: alpha(color, 0.18),
  };
}
